import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, mergeMap, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {of} from 'rxjs';
import * as ErrorActions from '../../error/store/error.actions';
import * as SpecialOfferActions from './special-offer.actions';
import {SpecialOfferService} from '../special-offer.service';
import {PaymentService} from '../../payment/payment.service';
import {Store} from '@ngrx/store';
import * as fromApp from '../../store/app.reducers';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class SpecialOfferEffects {

  actualSpecialOffer = createEffect(() => this.actions$
    .pipe(
      ofType(SpecialOfferActions.GET_SPECIAL_OFFER_ACTUAL),
      switchMap(
        () => {
          return this.specialOfferService.getSpecialOfferActive().pipe(
            mergeMap(
              (response: any) => {
                const actions = [];
                if (response.offer !== undefined && response.offer !== null) {
                  actions.push({
                    type: SpecialOfferActions.SAVE_SPECIAL_OFFER_ACTUAL,
                    payload: response.offer
                  });
                }
                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  useSpecialOffer = createEffect(() => this.actions$
    .pipe(
      ofType(SpecialOfferActions.USE_SPECIAL_OFFER),
      map(
        (data: {type: string, payload: number}) => {
          return data.payload;
        }
      ),
      withLatestFrom(this.store),
      switchMap(
        (data: any) => {
          const id = data[0];
          const state: fromApp.AppState = data[1];
          return this.specialOfferService.useSpecialOffer(id).pipe(
            mergeMap(
              (response: any) => {
                const actions = [];
                this.notifierService.success('Special offer has been paid');
                this.specialOfferService.setSpecialOfferCloseState(id, true);
                this.paymentService.redirectAfterPayment(state.user);
                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  constructor(
    private actions$: Actions,
    private specialOfferService: SpecialOfferService,
    private paymentService: PaymentService,
    private router: Router,
    private notifierService: ToastrService,
    private store: Store<fromApp.AppState>
  ) {
  }
}
